import React from "react";

import CustomDatePicker from "./reusables/CustomDatePicker";
import { initDate } from "./Initializer";
import apiService from "../../../services/ApiService";
import { FieldByKindAndType } from "../../ModelDataPanel";
import snakeToPascal from "../../../tools";
import { useEditorStore } from "../../../shared/stores/useEditorStore";
import { useScenarioTree } from "../../../shared/hooks/queries/useScenarioTree";

export default function CrossField({ crossFieldObj }) {
    const scenarioId = useEditorStore(s => s.scenarioId) ?? 0;
    const { state } = useScenarioTree(scenarioId);

    const rootInputItem = state.Input.tree.items[state.Input.tree.rootId];
    const fieldToRender = {}

    if (!rootInputItem) return <div></div>;

    const selectFieldsToRender = (item: any) => {
        if (!item) return;

        if (crossFieldObj[item.type]) {
            fieldToRender[item.id] = {}
            crossFieldObj[item.type].map(name => {
                if (item.fields?.[name]) {
                    fieldToRender[item.id][name] = item.fields[name]
                }
            })
        }
        item.childrens?.map(id => selectFieldsToRender(state.Input.tree.items[id]))
    }

    const renderField = (name: string, kind: string, field: any, siblingFields?: any) => {

        const FieldToRender = FieldByKindAndType[kind][field.type];
        const flexDirection = (['bool'].indexOf(field.type) !== -1) ? 'flex-row' : 'flex-col';

        if (FieldToRender) {
            return (
                <div className={`flex ${flexDirection} mb-3`}>
                    <div className="text-lg mr-2 mb-1">
                        {name}
                    </div>
                    <FieldToRender name={name} field={field} siblingFields={siblingFields} />
                </div>
            )
        }
        else {
            return (
                <div></div>
            )
        }
    }

    const renderItem = (itemId, item) => {
        const treeItem = state.Input.tree.items[itemId];
        return (
            <div>
                <div className="text-2xl mb-1">
                    {treeItem?.name || 'Unknown'}
                </div>
                <div className="ml-3">
                    {Object.entries(item).map(([name, field]) => renderField(snakeToPascal(name), 'Input', field, treeItem?.fields))}
                </div>
            </div>
        )
    }

    selectFieldsToRender(rootInputItem);

    if (Object.keys(fieldToRender).length) {
        return (
            <div>
                {
                    Object.entries(fieldToRender).map(([itemId, item]: Array<string|any>) =>
                        renderItem(itemId, item)
                    )
                }
            </div>
        )
    }
    else {
        return (<div></div>)
    }
}
